<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-11-10 11:39:12
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_List_Chip_Status.vue
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-14 12:00:58
-->
<template>
  <v-chip
    :small="small"
    :pill="icon"
    :class="
      contentClass +
      ' ' +
      textColor +
      (icon && showIcon
        ? ' pl-1 pr-2 '
        : showIcon
        ? ''
        : close
        ? 'pl-2 pr-1'
        : ' px-3 ')
    "
    :label="!icon"
    :close="close"
    @click:close="$emit('close')"
    :style="
      icon ? {} : { borderLeft: !icon ? '8px solid ' + slideColor : 'none' }
    "
    class="text--primary"
    :color="bgColor"
  >
    <svg-icon
      size="18"
      v-if="icon && showIcon"
      :fill="slideColor ? slideColor : 'grey'"
      iconClass="LabeledColour"
      class="mr-1"
    />
    <slot name="status" />
  </v-chip>
</template>
<script>
export default {
  name: "StatusChip",
  props: {
    slideColor: { default: "grey", type: [String, Number] },
    bgColor: { default: "rgb(228, 228, 228)", type: [String, Number] },
    icon: { default: false, type: [Number, Boolean] },
    small: { default: true, type: [Number, Boolean] },
    close: { default: false, type: [Number, Boolean] },
    textColor: { default: "text--primary", type: [Number, String] },
    contentClass: { default: " my-1 ", type: [String] },
    showIcon: { default: true, type: [Number, Boolean] },
  },
  computed: {},
  data() {
    return {};
  },
};
</script>